import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/store';
//CHN pages
const LS01_OLD = () => import('@/view/v4/chineseScreen_CH2/LS01_old');

const CMD01 = () => import('@/view/v4/chineseScreen_CH2/CMD01');

const VAT01 = () => import('@/view/v4/chineseScreen_CH2/VAT01');

const CIT01 = () => import('@/view/v4/chineseScreen_CH2/CIT01');

const CIT02 = () => import('@/view/v4/chineseScreen_CH2/CIT02');

const FCV01 = () => import('@/view/v4/chineseScreen_CH2/FCV01');

const QZ01 = () => import('@/view/v4/chineseScreen_CH2/QZ01');

const QZ02 = () => import('@/view/v4/chineseScreen_CH2/QZ02');

const QZ04 = () => import('@/view/v4/chineseScreen_CH2/QZ04');

const CAD01 = () => import('@/view/v4/chineseScreen_CH2/CAD01');

const QZ06 = () => import('@/view/v4/chineseScreen_CH2/QZ06');

const QZ07 = () => import('@/view/v4/chineseScreen_CH2/QZ07');

const LKI03 = () => import('@/view/v4/chineseScreen_CH2/LKI03');

const MF01 = () => import('@/view/v4/chineseScreen_CH2/MF01');

const LS03 = () => import('@/view/v4/chineseScreen_CH2/LS03');

const CLP01 = () => import('@/view/v4/chineseScreen_CH2/CLP01');

const LS04 = () => import('@/view/v4/chineseScreen_CH2/LS04');

const LKI02 = () => import('@/view/v4/chineseScreen_CH2/LKI02');

const QZ03 = () => import('@/view/v4/chineseScreen_CH2/QZ03');

const LS01 = () => import('@/view/v4/chineseScreen_CH2/LS01');

const ifAuthenticated = (to, from, next) => {
  if (store.getters['auth/userStatus']) {
    store.dispatch('template/setLangOption', true);
    next();
  } else {
    next('/homepage');
  }
};
export default [
  // chinese route template
  {
    path: '/v4/LS01/:id',
    name: 'LS01',
    component: LS01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/VAT01/:id',
    name: 'VAT01',
    component: VAT01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CMD01/:id',
    name: 'CMD01',
    component: CMD01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CIT01/:id',
    name: 'CIT01',
    component: CIT01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CIT02/:id',
    name: 'CIT02',
    component: CIT02,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/FCV01/:id',
    name: 'FCV01',
    component: FCV01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/QZ01/:id',
    name: 'QZ01',
    component: QZ01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/QZ02/:id',
    name: 'QZ02',
    component: QZ02,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/QZ04/:id',
    name: 'QZ04',
    component: QZ04,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CAD01/:id',
    name: 'CAD01',
    component: CAD01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/QZ06/:id',
    name: 'QZ06',
    component: QZ06,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/QZ07/:id',
    name: 'QZ07',
    component: QZ07,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LKI03/:id',
    name: 'LKI03',
    component: LKI03,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/MF01/:id',
    name: 'MF01',
    component: MF01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LS03/:id',
    name: 'LS03',
    component: LS03,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/CLP01/:id',
    name: 'CLP01',
    component: CLP01,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LS04/:id',
    name: 'LS04',
    component: LS04,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/LKI02/:id',
    name: 'LKI02',
    component: LKI02,
    beforeEnter: ifAuthenticated,
  },
  {
    path: '/v4/QZ03/:id',
    name: 'QZ03',
    component: QZ03,
    beforeEnter: ifAuthenticated,
  },
];
